module.exports = global["vue-resource"] = require("-!./vue-resource.esm.js");